import React from 'react';
import format from 'date-fns/format'
import {Grid, Typography} from "@mui/material";
import  config  from "../../config";
import {log} from "../../utils/log";
import {isValid, parseISO} from "date-fns";
//import Styles from '../../assets/scss/print.scss';


type Props = {
  text?: string,
  eilId: number,
  eId: number,
  aluno: any
 
};

type State = {
  checked: boolean,
};

const sxStyles = {
  marginGrid: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '30px',
    marginRight: '20px',
    padding: '0px'
    
  },
  mainGrid: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '30px',
    padding: '0px'
    
  },
  
  cabecalhoDados: {
    display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', width: '50%'
  },

  fieldGrid: {
  
  },
  summary:{
    backgroundColor: '#c5c5c5'
  },
  disciplinaColuna: {
     display: 'flex',
     flexDirection: 'row',
     flexWrap: 'nowrap',
      margin: '0px',
      padding: '0px'
  }
  
}


export class FichaDisciplinasImpressao extends React.PureComponent< Props, State> {
  
  constructor( props:  Props) {
    super(props);
    
    this.state = { checked: false };
  }

  render() {
    const aluno =  this.props.aluno;
  
    log(3,"printable this.props.aluno object", this.props.eilId, this.props.eId, aluno);
  
    const {eId} = this.props;
    const ixdetail : any = aluno.enrollmentInLevel.findIndex((eil: any) => eil.id === this.props.eilId) ;
    
    if (ixdetail < 0) {
      return (<div><Typography variant={'caption'}>not found. {this.props.eId}</Typography>
      </div>)
    }
    
    if (!aluno || !this.props.eId || !aluno.enrollmentInLevel
          || aluno.enrollmentInLevel.length === 0 ||  !aluno.enrollmentInLevel[ixdetail].enrollment ) {
      return (<div><Typography variant={'caption'}>{this.props.eId}</Typography>
      </div>)
    }
    
    
    
    
   // log(3,"enrollemtnmatricula",ixdetail);
    const data = aluno.enrollmentInLevel[ixdetail].enrollment.find((e: any) => e.id === this.props.eId) ;
    
  
  //  log(3,"printable data", this.props.eId,  data);
  
  
 //   log(3,"printable this.props.aluno object", this.props.eId, aluno);
  
  
  //  log(3,'********* PRINTABLE ', data)
  
    let disccol1 : JSX.Element = <React.Fragment/>;
    let disccol2 : JSX.Element = <React.Fragment/>;
    let jdiscOfferContent : JSX.Element = <React.Fragment/>;
  
    if (data.disciplineEntree) {
      const disccol1Rows : any = [];
      const disccol2Rows : any = [];
      
      const discOfferContent : any = [];
    
      let x = 1;
    
      data.disciplineEntree
          .sort((a: any, b: any) => a.disciplineOffer.InitialDate - b.disciplineOffer.InitialDate)
          .map((disp : any, key: number) => {
      
        log(4,'printable disciline', disp.disciplineOffer.classOffer.Description, disp);
        if (disp.Status === '' || disp.Status === null || disp.Status === 1) {
          var myRow =
              (<Grid key={key} id={'gridDisplinaMatriculada'} item container sx={{...sxStyles.disciplinaColuna, sm:12, md:12, lg:12, xl:12}} >
                  <Grid item sx={{ width: '25%', margin: '0px', padding: '0px'}}>
                      <Typography variant={'caption'}>{disp.disciplineOffer.discipline.Description} {disp.disciplineOffer.disciplineModule.Description} </Typography>
                  </Grid>
                  <Grid item sx={{ width: '25%', margin: '0px', padding: '0px'}}>
                      <Typography variant={'caption'}>{disp.disciplineOffer.classOffer.Description}  ({disp.disciplineOffer.id})</Typography>
                  </Grid>
                  <Grid item sx={{ width: '15%', margin: '0px', padding: '0px'}}>
                      <Typography variant={'caption'}>{disp.disciplineOffer.classOffer.Room}  {disp.disciplineOffer.classOffer.Shift}</Typography>
                  </Grid>
                  <Grid item sx={{ width: '15%', margin: '0px', padding: '0px'}}>
                      <Typography variant={'caption'}>{isValid(parseISO(disp.disciplineOffer.InitialDate)) ? format(parseISO(disp.disciplineOffer.InitialDate), 'dd/MM/yyyy') : ''}</Typography>
                  </Grid>
                <Grid item sx={{ width: '15%', margin: '0px', padding: '0px'}}>
                  <Typography variant={'caption'}>{isValid(parseISO(disp.disciplineOffer.EndDate)) ? format(parseISO(disp.disciplineOffer.EndDate), 'dd/MM/yyyy') : ''}</Typography>
                </Grid>
                {/*<td>({disp.})</td>*/}
              </Grid>);
        
             disccol1Rows.push(myRow);
             
             
             //discOfferContent
             if (disp.disciplineOffer.disciplineOfferContent) {
                disp.disciplineOffer.disciplineOfferContent.map((doc: any) => {
                    const ndoc = {
                        ...doc,
                        disciplina: disp.disciplineOffer.discipline.Description,
                        modulo: disp.disciplineOffer.disciplineModule.Description,
                    }
                    
                    discOfferContent.push(ndoc);
                });
             }
         
        }
      });
    
      disccol1 = (
          <Grid item sx={{...sxStyles.disciplinaColuna,  flexWrap: 'wrap', width:'98%', margin: '3px', padding: '3px', border: '1px solid black', borderRadius: '10px' }} >
              <Grid id={'gridDisplinaMatriculada'} item container sx={{...sxStyles.disciplinaColuna }} >
                  <Grid item sx={{ width: '25%', margin: '0px', padding: '0px'}}>
                      <Typography variant={'caption'}>DISCIPLINA</Typography>
                  </Grid>
                  <Grid item sx={{ width: '25%', margin: '0px', padding: '0px'}}>
                      <Typography variant={'caption'}>CLASSE</Typography>
                  </Grid>
                  <Grid item sx={{ width: '15%', margin: '0px', padding: '0px'}}>
                      <Typography variant={'caption'}>SALA TURNO</Typography>
                  </Grid>
                  <Grid item sx={{ width: '15%', margin: '0px', padding: '0px'}}>
                      <Typography variant={'caption'}>INICIO</Typography>
                     
                  </Grid>
                  <Grid item sx={{ width: '15%', margin: '0px', padding: '0px'}}>
                     
                      <Typography variant={'caption'}>FINAL</Typography>
                  </Grid>
                  {/*<td>({disp.})</td>*/}
              </Grid>
              {disccol1Rows}
           </Grid>
          
      );
      

        
        jdiscOfferContent = (
          <Grid item sx={{...sxStyles.disciplinaColuna, flexWrap:'wrap', width:'98%',  margin: '2px', padding: '0px', border: '1px solid black', borderRadius: '10px'}} >
              <Grid id={'gridDisplinaAgendaHeader'} item container sx={{...sxStyles.disciplinaColuna, width:'32%' }} >
                  <Grid item sx={{ width: '48%', margin: '0px', padding: '0px'}}>
                      <Typography variant={'caption'}>DATA HORA</Typography>
                  </Grid>
                  <Grid item sx={{ width: '52%', margin: '0px', padding: '0px'}}>
                      <Typography variant={'caption'}>DISCIPLINA</Typography>
                  </Grid>
                 
              </Grid>
              <Grid id={'gridDisplinaAgendaHeader2'} item container sx={{...sxStyles.disciplinaColuna, width:'32%' }} >
                 
                  <Grid item sx={{ width: '42%', margin: '0px', padding: '0px'}}>
                      <Typography variant={'caption'}>DATA HORA</Typography>
                  </Grid>
                  <Grid item sx={{ width: '58%', margin: '0px', padding: '0px'}}>
                      <Typography variant={'caption'}>DISCIPLINA</Typography>
                  </Grid>
              </Grid>
              <Grid id={'gridDisplinaAgendaHeader2'} item container sx={{...sxStyles.disciplinaColuna, width:'32%' }} >
                  <Grid item sx={{ width: '42%', margin: '0px', padding: '0px'}}>
                      <Typography variant={'caption'}>DATA HORA</Typography>
                  </Grid>
                  <Grid item sx={{ width: '58%', margin: '0px', padding: '0px'}}>
                      <Typography variant={'caption'}>DISCIPLINA</Typography>
                  </Grid>
              </Grid>
              
              
              {
                  discOfferContent
                      .sort((a: any, b: any) => a.Date - b.Date)
                      .map((doc: any, key:number) => {
                      return (
                          <React.Fragment key={key}>
                              
                                <Grid item sx={{ display:'flex', flexWrap:'nowrap', width: '32%', margin: '0px', padding: '0px'}}>
                                    <Grid item sx={{...sxStyles.disciplinaColuna, flexWrap:'wrap', width:'5%',  margin: '2px', padding: '0px', border: '1px solid black', borderRadius: '2px'}} >
                                    </Grid>
                                    <Grid item sx={{ width: '32%', margin: '0px', padding: '0px'}}>
                                        <Typography variant={'caption'}>{isValid(parseISO(doc.Date))? format(parseISO(doc.Date), "dd/MM HH:mm"): "F" } </Typography>
                                    </Grid>
                                    <Grid item sx={{ width: '63%', margin: '0px', padding: '0px'}}>
                                        <Typography variant={'caption'}>{doc.disciplina} {doc.modulo}</Typography>
                                    </Grid>
                                </Grid>
                          </React.Fragment>
                              
                              );
                              
                  })
              }
             
          </Grid>
      );
      
    }

    log(3,"FichaMatruloa returning...")
  
    return (
        <div className='print'>
          <Grid container sx={{...sxStyles.marginGrid}}>
          <Grid id='cabecalho' container sx={{...sxStyles.mainGrid}}>
            <Grid container item style={{ }}>
              <Grid container item style={{ width: '25%'}}>
                <img className="picture-src"
                     src="https://api-fermi.cientificoeducacao.com.br/api/PersonPics/fermi-images.cientificoeducacao.com.br/download/logoCientifico.png"
                     width={200} height={63}></img>
              </Grid>
              <Grid container item  sx={{ ...sxStyles.cabecalhoDados}}>
                <Typography variant={'caption'} style={{ lineHeight: 0}}>CIENTIFICO</Typography><br/>
                <Typography variant={'caption'} style={{ lineHeight: 0}}>EDUCAÇÃO DE JOVENS E ADULTOS</Typography><br/>
                <Typography variant={'caption'} style={{ lineHeight: 0}}>EAD
                  - {aluno.enrollmentInLevel[ixdetail] ? aluno.enrollmentInLevel[ixdetail].level.OfficialText : ""}</Typography><br/>
                <Typography variant={'caption'} style={{ lineHeight: 0}}>GRADE DE DISCIPLINAS</Typography><br/>

              </Grid>
           
            </Grid>
          </Grid>
        
          <Grid id='identificacao' container>
            <Grid container item >
              <Grid item style={{ width: '70%'}}>
                <Typography variant={'caption'}>ALUNO ({data ? data.id : ""}):</Typography>
                <Typography id='Aluno' className="fieldname">{aluno ? aluno.Name : ""}</Typography>
              </Grid>
              <Grid item style={{ width: '15%'}}>
                <Typography variant={'caption'}>CPF:</Typography>
                <Typography className="fieldname" >{aluno ? aluno.IndividualIdentity : ""}</Typography>
              </Grid>
              <Grid item style={{ width: '15%'}}>
                <Typography variant={'caption'}>CARNÊ:</Typography>
                <Typography id='Carne' className="fieldname">{data.enrollment ? data.enrollment.PaymentCard : ""}</Typography>
              </Grid>
            </Grid>
          </Grid>
              
              <Grid item container style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap',  width: '100%', margin: '0px', padding: '0px'}}>
                DISCIPLINAS MATRICULADAS
              </Grid>
            <Grid item container style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap',  width: '94%', margin: '0px', padding: '0px'}}>
                  {disccol1}
            </Grid>
              
              <Grid item container style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap',  width: '100%', margin: '0px', padding: '0px'}}>
                  AGENDA - REALIZADA E PREVISTA
              </Grid>
              
              <Grid item container style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap',  width: '94%', margin: '0px', padding: '0px'}}>
                  {jdiscOfferContent}
              </Grid>
              
              
              
              
       
          </Grid>
        </div>
    );
  
  }

}



export default (FichaDisciplinasImpressao)

export const FunctionalFichaDisciplinaComponentToPrint = React.forwardRef<FichaDisciplinasImpressao | null,  Props>((props, ref) => {
  // eslint-disable-line max-len
  log(3,"Execute FunctionalComponentToPrint");
  return <FichaDisciplinasImpressao ref={ref} {...props} />;
});
